module.exports = __webpack_public_path__ + "img/shrimps-2.aea6dd27.jpg";